import englishLayout from "./english"
import thaiLayout from "./thai"
export const keyboardLayouts = {
  en: englishLayout,
  th: thaiLayout,
}
